import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GoogleMapsInformation } from '../interfaces/data';

@Injectable({
  providedIn: 'root'
})
export class MapsInformationService {
  private mapsInformationSubject = new Subject<GoogleMapsInformation>();
  public mapsInformation$ = this.mapsInformationSubject.asObservable();

  private countryInformationSubject = new Subject<string>();
  public countryInformation$ = this.countryInformationSubject.asObservable();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  setMapsInformation(change: GoogleMapsInformation) {
    this.mapsInformationSubject.next(change);
  }

  getMapsInformation() {
    return this.mapsInformation$;
  }

  setCountryInformation(change: string) {
    this.countryInformationSubject.next(change);
  }

  getCountryInformation() {
    return this.countryInformation$;
  }
}
